import React from "react"
import { connect } from "react-redux"

import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined"
import IndeterminateCheckBoxOutlinedIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined"

import {
  addItem,
  removeItem,
  clearItemFromCart,
} from "../../redux/cart/cart.actions"

import "./CheckoutItem.scss"

const formatDate = (date) => {
  const formDate = new Date(date)
  let day = formDate.getDate()
  let month = formDate.getMonth() + 1
  const year = formDate.getFullYear()

  if (day.toString().length === 1) day = "0" + day
  if (month.toString().length === 1) month = "0" + month

  return day + "/" + month + "/" + year
}

const CheckoutItem = ({ cartItem, addItem, removeItem, clearItem }) => {
  const { dateSelected, quantity, maxQty } = cartItem

  const dateCourse =
    dateSelected?.day && dateSelected?.hour
      ? `${formatDate(dateSelected.day)} - ${dateSelected.hour}`
      : ""

  const isCombo = cartItem?.is_combo || cartItem?.isCombo
  const qty = isCombo ? 1 : quantity || 1
  const max = Number(maxQty)
  const hasMax = Number.isFinite(max) && max > 0
  const canAddMore = !hasMax || qty < max

  return (
    <div className="checkout-item">
      <span className="name">
        Product: {cartItem.name} {dateCourse}
      </span>

      {/* Quantity controls (don’t show for free items) */}
      {cartItem.price !== 0 && !isCombo ? (
        <div className="qty-controls">
          <span
            className="qty-btn remove-button"
            onClick={() => removeItem(cartItem)}
            title="Decrease"
          >
            <IndeterminateCheckBoxOutlinedIcon />
          </span>

          <span className="qty">{qty}</span>

          <span
            className={`qty-btn add-button ${canAddMore ? "" : "disabled"}`}
            onClick={() => {
              if (!canAddMore) return
              addItem(cartItem)
            }}
            title={hasMax ? `Max: ${max}` : "Increase"}
          >
            <AddCircleOutlineOutlinedIcon />
          </span>
        </div>
      ) : null}

      <span className="price">€{cartItem.price * qty}</span>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  addItem: (item) => dispatch(addItem(item)),
  removeItem: (item) => dispatch(removeItem(item)),
  clearItem: (item) => dispatch(clearItemFromCart(item)),
})

export default connect(null, mapDispatchToProps)(CheckoutItem)
